import { Component, Input } from '@angular/core';
import { faImage, faVideo } from '@fortawesome/pro-regular-svg-icons';

import { MediaView } from '@eiq/files/models';

import { FileType } from '@empathy/global/data';

@Component({
  selector: 'empathy-media-view',
  templateUrl: 'media-view.component.html',
  styleUrls: ['./media-view.component.scss']
})
export class MediaViewComponent {
  @Input() media: MediaView;
  @Input() url: string;
  @Input() size: { width: string | number; height: string | number } = { width: 126, height: 126 };
  @Input() isExpanded: boolean;

  faImage = faImage;
  faVideo = faVideo;
  fileType = FileType;
}
